import type { VectorVertex } from "@/document/model/vectorNetwork";

export const VECTOR_VERTEX_SNAP_DISTANCE = 0.5;

export function findVertexSnapTarget(
  vertices: VectorVertex[],
  draggedVertexId: string,
  point: { x: number; y: number },
  maxDistance = VECTOR_VERTEX_SNAP_DISTANCE,
): VectorVertex | undefined {
  let closest: VectorVertex | undefined;
  let closestDistance = maxDistance;

  for (const vertex of vertices) {
    if (vertex.id === draggedVertexId) {
      continue;
    }

    const distance = Math.hypot(vertex.x - point.x, vertex.y - point.y);
    if (distance <= closestDistance) {
      closest = vertex;
      closestDistance = distance;
    }
  }

  return closest;
}

export function snapPointToVertex(point: { x: number; y: number }, vertices: VectorVertex[], draggedVertexId: string): { x: number; y: number } {
  const target = findVertexSnapTarget(vertices, draggedVertexId, point);
  return target ? { x: target.x, y: target.y } : point;
}
